import {
  KnowledgeBase,
  KnowledgeBaseFetchArgs,
  getKnowledgeBase,
} from '../assets/ts/data/knowledge-base'
import useServerData from './use-server-data'

function useKnowledgeBase(
  fetchArgs: KnowledgeBaseFetchArgs,
  waitOnParentDependency = false
) {
  const {
    data: KnowledgeBaseData,
    error: KnowledgeBaseDataError,
    fetchData: fetchKnowledgeBaseData,
    isLoading: KnowledgeBaseDataIsLoading,
  } = useServerData<KnowledgeBase, KnowledgeBaseFetchArgs>(
    getKnowledgeBase,
    fetchArgs,
    waitOnParentDependency
  )

  return {
    KnowledgeBaseData,
    KnowledgeBaseDataError,
    KnowledgeBaseDataIsLoading,
    fetchKnowledgeBaseData,
  }
}

export default useKnowledgeBase
